import { API, METHODS } from "../../../shared/constants";
import { request } from "../../../shared/utils";
import { GenerateTokenPayload } from "../interfaces";

export default {
  generateToken: (payload: GenerateTokenPayload) => request(METHODS.POST, API.GENERATE_EIGHT_TO_EIGHT_TOKEN)(payload),
  loadClassrooms: (payload: number) => request(METHODS.GET, API.GET_CLASSROOMS(payload))(),
};
